(() => {
  const element = document.getElementById(
    'test-free-gift-config'
  );

  if (!element || window.testFreeGiftStarted) return;
  window.testFreeGiftStarted = true;

  const config = JSON.parse(element.textContent);
  const root = window.Shopify?.routes?.root || '/';

  // Stessa proprietà della versione precedente:
  // consente di riconoscere anche il vecchio omaggio di prova.
  const marker = '_test_free_gift';
  const markerValue = 'test-free-gift-v1';
  const legacyVariantId = 59696374907228;

  const serverTime = Number(config.serverNow) * 1000;
  const loadedAt = performance.now();

  const currentTime = () =>
    serverTime + (performance.now() - loadedAt);

  const promotionIsOpen = () => {
    const now = currentTime();

    return (
      config.enabled &&
      now >= Date.parse(config.startsAt) &&
      now < Date.parse(config.endsAt)
    );
  };

  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        ...(body
          ? { 'Content-Type': 'application/json' }
          : {})
      },
      ...(body
        ? { body: JSON.stringify(body) }
        : {})
    });

    if (!response.ok) {
      throw new Error(
        `Richiesta carrello fallita: ${response.status}`
      );
    }

    return response.json();
  }

  const isMarked = item =>
    item.properties?.[marker] === markerValue;

  const isManagedGift = item =>
    Number(item.variant_id) === Number(config.variantId) &&
    isMarked(item);

  const isLegacyGift = item =>
    Number(item.variant_id) === legacyVariantId &&
    isMarked(item);

  const isValidatedGift = item =>
    Number(item.final_line_price) === 0 &&
    (item.line_level_discount_allocations || []).some(
      allocation =>
        allocation.discount_application?.title ===
        config.discountTitle
    );

  async function removeMatching(predicate) {
    // Rileggere il carrello dopo ogni modifica:
    // le chiavi delle righe possono cambiare.
    for (let attempt = 0; attempt < 20; attempt += 1) {
      const cart = await request('cart.js');
      const item = cart.items.find(predicate);

      if (!item) return;

      await request('cart/change.js', {
        id: item.key,
        quantity: 0
      });
    }

    throw new Error('Rimozione omaggi non completata.');
  }

  async function syncGift() {
    let changed = false;

    try {
      let cart = await request('cart.js');

      // Pulizia del vecchio Prodotto di prova,
      // solo se inserito dal codice precedente.
      if (cart.items.some(isLegacyGift)) {
        await removeMatching(isLegacyGift);
        changed = true;
        cart = await request('cart.js');
      }

      const eligible =
        promotionIsOpen() &&
        config.currency === 'EUR' &&
        cart.currency === 'EUR' &&
        config.eligibleTotal >= config.threshold;

      const managed = cart.items.filter(isManagedGift);

      const manualGift = cart.items.some(
        item =>
          Number(item.variant_id) === Number(config.variantId) &&
          !isMarked(item)
      );

      if (!eligible || manualGift) {
        if (managed.length) {
          await removeMatching(isManagedGift);
          changed = true;
        }
      } else if (managed.length) {
        const gift = managed[0];

        if (
          managed.length !== 1 ||
          gift.quantity !== 1 ||
          !isValidatedGift(gift)
        ) {
          await removeMatching(isManagedGift);
          changed = true;
        }
      } else {
        // Evita tentativi ripetuti dopo un rifiuto dello sconto.
        // Un cambiamento al carrello permette un nuovo tentativo.
        const signature = JSON.stringify({
          title: config.discountTitle,
          items: cart.items.map(item => [
            item.key,
            item.quantity,
            item.final_line_price
          ])
        });

        let lastFailed = null;
        try {
          lastFailed = sessionStorage.getItem(
            'promo31-failed-cart'
          );
        } catch (_) {}

        if (lastFailed !== signature) {
          await request('cart/add.js', {
            items: [{
              id: Number(config.variantId),
              quantity: 1,
              properties: {
                [marker]: markerValue
              }
            }]
          });

          changed = true;

          const updated = await request('cart.js');
          const gift = updated.items.find(isManagedGift);

          if (
            !promotionIsOpen() ||
            !gift ||
            !isValidatedGift(gift)
          ) {
            await removeMatching(isManagedGift);

            try {
              sessionStorage.setItem(
                'promo31-failed-cart',
                signature
              );
            } catch (_) {}

            console.warn(
              'Omaggio rimosso: Promo_31-Ottobre ' +
              'non applicata o non gratuita.'
            );
          } else {
            try {
              sessionStorage.removeItem(
                'promo31-failed-cart'
              );
            } catch (_) {}
          }
        }
      }

      //if (changed) window.location.reload();
      if (changed) {
        const reloadKey = 'promo31-auto-reload';

            try {
              const lastReload = Number(
              sessionStorage.getItem(reloadKey) || 0
              );

    // Allow at most one automatic reload per 60 seconds.
    if (Date.now() - lastReload > 60000) {
      sessionStorage.setItem(
        reloadKey,
        String(Date.now())
      );

      window.location.reload();
    } else {
      console.warn(
        'Gift cart changed again after reload. ' +
        'Automatic reload stopped. Check gift validation.'
      );
    }
  } catch (error) {
    // If session storage is unavailable, do not reload.
    console.warn('Automatic gift reload skipped.', error);
  }
}
    } catch (error) {
      console.error(
        'Sincronizzazione omaggio non completata. ' +
        'Controllare il carrello prima del checkout.',
        error
      );
    }
  }

  syncGift();
})();
